var map = {
	"./2579410-alert-icon.webp": 379,
	"./612x612.svg": 1557,
	"./684832 1.webp": 2254,
	"./860x720.svg": 1576,
	"./Clock_Icon.webp": 8486,
	"./DrDagmarBlenckeKoethen2.webp": 978,
	"./HajiAhmadianHnoFalkenberg1.webp": 9330,
	"./HalsNasenOhrenPraxisEpikurFalkenberg2.webp": 6975,
	"./Mannschaftsfoto.webp": 9733,
	"./Mannschaftsfoto_wide.webp": 9405,
	"./MariaSchwabKinderaerztinHerzberg1.webp": 814,
	"./PraxisMendeKaupischEpikurLauchhammer.webp": 9007,
	"./burgerMenu.webp": 9765,
	"./chevron_icon_down.webp": 4740,
	"./chevron_icon_down_orange.webp": 2276,
	"./chevron_icon_down_white.webp": 7682,
	"./chevron_icon_up.webp": 4292,
	"./chevron_icon_up_orange.webp": 1806,
	"./chevron_icon_up_white.webp": 4452,
	"./chevron_left_black .webp": 3884,
	"./chevron_left_orange.webp": 3316,
	"./chevron_right_black.webp": 4691,
	"./chevron_right_orange.webp": 4726,
	"./contact_phone_icon.webp": 6661,
	"./desktop_1.webp": 79,
	"./desktop_2.webp": 3633,
	"./dummy-780x439.webp": 9483,
	"./gettyimages-647660306-612x612.webp": 6812,
	"./hero_desktop.webp": 1703,
	"./istockphoto-1238687200-612x612_1.webp": 6413,
	"./istockphoto-1238687200-612x612_desktop_1.webp": 6593,
	"./istockphoto-1308717786-612x612.jpg": 2373,
	"./istockphoto-1308717786-612x612.webp": 8389,
	"./istockphoto-1308717786-612x612_desktop.webp": 3536,
	"./istockphoto-1343539369-612x612_2.png": 8402,
	"./istockphoto-1456797132-1024x1024.webp": 5727,
	"./location-pin-svgrepo-com 3.webp": 8285,
	"./logo.webp": 9437,
	"./logo2.webp": 6257,
	"./mail_icon.webp": 3563,
	"./mobile_1.webp": 3155,
	"./mobile_2.webp": 1730,
	"./placeholder_612.webp": 2595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;